import React, { forwardRef, useCallback, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import type { HTMLProps, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import track from 'src/utils/analytics';
import SimpleKeyboard, { Layout } from './SimpleKeyboard';
import useSettings from 'src/hooks/useSettings';

interface PageProps extends HTMLProps<HTMLDivElement> {
  children?: ReactNode;
  title?: string;
}

const keyboardBoxHeight = '455px';

const Page = forwardRef<HTMLDivElement, PageProps>(({
  children,
  title = '',
  ...rest
}, ref) => {
  const location = useLocation();
  const mainTitle = 'EXO Validator Display';
  const { isKeyboardVisible, keyboardProps: { handleChange, keyboardRef, layout = Layout.Qwerty } = {} } = useSettings();
  const sendPageViewEvent = useCallback(() => {
    track.pageview({
      page_path: location.pathname
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    sendPageViewEvent();
  }, [sendPageViewEvent]);

  return (
    <div
      ref={ref as any}
      {...rest}
    >
      <Box display={'flex'} flexDirection={'column'} height={'100vh'}>
        <Box flexGrow={1} height={isKeyboardVisible ? `calc(100% - ${keyboardBoxHeight})` : '100%'} overflow={'auto'}>
          <Helmet>
            <title>{title ? `${title} - ${mainTitle}` : mainTitle}</title>
          </Helmet>
          {children}
        </Box>
        {isKeyboardVisible ? <Box height={keyboardBoxHeight} zIndex={9999}>
          <SimpleKeyboard
            keyboardRef={keyboardRef}
            onChange={(val) => {
              handleChange(val);
            }}
            layout={layout}
          />
        </Box> : ''}
      </Box>
    </div>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default Page;
